"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailableUserGroupAccessGrantee = exports.isAvailableUserAccessGrantee = exports.isGranularAccessGrantee = exports.isGranularUserGroupAccessGrantee = exports.isGranularUserAccessGrantee = exports.isUserGroupAccessGrantee = exports.isUserAccessGrantee = exports.isGranularAccess = exports.isGranularUserGroupAccess = exports.isGranularUserAccess = exports.isUserGroupAccess = exports.isUserAccess = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2023 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Tests whether the provided object is an instance of {@link IUserAccess}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isUserAccess = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "user";
};
/**
 * Tests whether the provided object is an instance of {@link IUserGroupAccess}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isUserGroupAccess = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "group";
};
/**
 * Tests whether the provided object is an instance of {@link IGranularUserAccess}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isGranularUserAccess = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "granularUser";
};
/**
 * Tests whether the provided object is an instance of {@link IGranularUserAccess}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isGranularUserGroupAccess = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "granularGroup";
};
/**
 * Tests whether the provided object is an instance of {@link IGranularUserAccess} or {@link IGranularUserGroupAccess}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isGranularAccess = function (obj) {
    return exports.isGranularUserAccess(obj) || exports.isGranularUserGroupAccess(obj);
};
/**
 * Tests whether the provided object is an instance of {@link IUserAccessGrantee}.
 *
 * @param obj - object to test
 * @public
 */
exports.isUserAccessGrantee = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "user";
};
/**
 * Tests whether the provided object is an instance of {@link IUserGroupAccessGrantee}.
 *
 * @param obj - object to test
 * @public
 */
exports.isUserGroupAccessGrantee = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "group";
};
/**
 * Tests whether the provided object is an instance of {@link IGranularUserAccessGrantee}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isGranularUserAccessGrantee = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "granularUser";
};
/**
 * Tests whether the provided object is an instance of {@link IGranularUserGroupAccessGrantee}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isGranularUserGroupAccessGrantee = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "granularGroup";
};
/**
 * Tests whether the provided object is an instance of {@link IGranularAccessGrantee}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isGranularAccessGrantee = function (obj) {
    return exports.isGranularUserAccessGrantee(obj) || exports.isGranularUserGroupAccessGrantee(obj);
};
/**
 * Tests whether the provided object is an instance of {@link IAvailableUserAccessGrantee}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isAvailableUserAccessGrantee = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "user";
};
/**
 * Tests whether the provided object is an instance of {@link IAvailableUserGroupAccessGrantee}.
 *
 * @param obj - object to test
 * @alpha
 */
exports.isAvailableUserGroupAccessGrantee = function (obj) {
    return !isEmpty_1.default(obj) && obj.type === "group";
};
//# sourceMappingURL=index.js.map